import React from 'react';

interface ChevronRightProps {
  size?: number;
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const ChevronRight: React.FC<ChevronRightProps> = (props) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={props.size || props.width || 24}
      height={props.size || props.height || 24}
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={props.color || "currentColor"} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={props.className || ""}
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );
};

export default ChevronRight;
